// extracted by mini-css-extract-plugin
export default {"contentBtnWrapper":"ActionsComponent_contentBtnWrapper__zTax6"};